import { ReportType } from '@/domain/ReportType'
import axios from 'axios'

/**
 * 報告書タイプサービス
 */
export default class ReportTypesService {
    /** インスタンス */
    private static _instance: ReportTypesService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new ReportTypesService();
        }
        return this._instance;
    }
    
    /**
     * 新規作成
     */
    public async createNew(): Promise<ReportType> {
        return await axios.get("/api/report_type/new")
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }
    
    /**
     * 編集
     */
    public async edit(no: string): Promise<ReportType> {
        return await axios.get(`/api/report_type/edit/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 新規保存
     */
    public async create(dto: ReportType): Promise<ReportType> {
        return await axios.post("/api/report_type/new", dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 保存
     */
    public async update(dto: ReportType): Promise<ReportType> {
        return await axios.put(`/api/report_type/edit/${dto.code}`, dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 報告書タイプ一覧を検索
     */
    public async findAll(): Promise<ReportType[]> {
        return await axios.get("/api/report_types")
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as ReportType[]).map(x => this.convert(x))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 受信データの変換
     * @param data
     */
    // eslint-disable-next-line
    private convert(data: any): ReportType {
        const reportType = data as ReportType
        return new ReportType({ ...reportType })
    }
}
